import { render, staticRenderFns } from "./ArrangeForServiceCmPpmRelocEnfrcInstructions.vue?vue&type=template&id=5c460cc2"
import script from "./ArrangeForServiceCmPpmRelocEnfrcInstructions.vue?vue&type=script&lang=ts"
export * from "./ArrangeForServiceCmPpmRelocEnfrcInstructions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports